import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.99984 2.64435C7.1582 2.64435 7.30815 2.71404 7.40958 2.83413L9.76938 5.63789L11.7708 4.3169C11.8594 4.25859 11.9632 4.22778 12.0693 4.22833C12.1754 4.22889 12.2789 4.26078 12.3669 4.32001C12.5464 4.44103 12.6338 4.65788 12.5878 4.8682L11.2543 10.9396C11.2279 11.0579 11.1618 11.1637 11.067 11.2393C10.9722 11.315 10.8545 11.356 10.7332 11.3556H3.26646C3.1452 11.356 3.02743 11.315 2.93266 11.2393C2.83788 11.1637 2.7718 11.0579 2.74535 10.9396L1.41191 4.8682C1.38951 4.76521 1.39859 4.65786 1.43798 4.5601C1.47738 4.46235 1.54525 4.37869 1.6328 4.32001C1.72079 4.26078 1.82432 4.22889 1.93038 4.22833C2.03644 4.22778 2.1403 4.25859 2.2289 4.3169L4.2303 5.63789L6.5901 2.83413C6.69184 2.71404 6.84148 2.64435 6.99984 2.64435ZM6.18316 9.07415C6.18316 9.36038 6.42708 9.59247 6.72761 9.59247H7.27206C7.5726 9.59247 7.81651 9.36038 7.81651 9.07415C7.81651 8.78793 7.5726 8.55552 7.27206 8.55552H6.72761C6.42708 8.55552 6.18316 8.78762 6.18316 9.07415Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }